// var testi_carousels = document.querySelectorAll(".testimonials--body.swiper-container");
// if (($('.testimonials--body.swiper-container .testimonials--block').length <= 3 && window.innerWidth >= 1400) || ($('.testimonials--body.swiper-container .testimonials--block').length <= 1 && window.innerWidth < 1400)) {
//   $('.testimonials--body.swiper-container .swiper-button-next, .testimonials--body.swiper-container .swiper-button-prev ').hide();
// }
// testi_carousels.forEach((carou) => {
//   new Swiper(carou, {
//     // Optional parameters
//     direction: "horizontal",
//     slidesPerView: 1,
//     speed: 1000,
//     breakpoints: {
//       300: {
//         slidesPerView: 1,
//         spaceBetween: 10,
//       },
//       800: {
//         slidesPerView: 2,
//         spaceBetween: 10,
//       },
//       1100: {
//           slidesPerView: 3
//       }
//     },

//     // Navigation arrows
//     navigation: {
//       nextEl: `.swiper-button-next-${carou.getAttribute("data-id")}`,
//       prevEl: `.swiper-button-prev-${carou.getAttribute("data-id")}`,
//     },
//   });
// });


 window.onload = function() {
  var testi_carousels = document.querySelectorAll(".testimonials--body.swiper-container");
  testi_carousels.forEach((carou) => {
    new Swiper(carou, {
      // Optional parameters
      direction: "horizontal",
      slidesPerView: 1,
      speed: 1000,
      watchOverflow: true,
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 25,
        },
        749: {
          slidesPerView: 2
        },
        1100: {
          slidesPerView: 3
        }
      },
  
      // Navigation arrows
      navigation: {
        nextEl: `.swiper-button-next-${carou.getAttribute("data-id")}`,
        prevEl: `.swiper-button-prev-${carou.getAttribute("data-id")}`,
      },
    });
  });
}